export enum VolumeWeightDisplayType {
  Volume = 0,
  Weight = 1,
  VolumeWeight = 2,
}